import { useState, type FormEvent } from 'react';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import { Alert, Box, Button, Link, TextField } from '@mui/material';
import { useAuthStore } from '../../stores/authStore';
import { ApiError } from '../../lib/apiClient';
import PasswordField from '../../components/PasswordField';
import AuthLayout from './AuthLayout';

export default function LoginPage() {
  const login = useAuthStore((s) => s.login);
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as { from?: string; passwordReset?: boolean } | null;
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login(email, password);
      navigate(state?.from ?? '/', { replace: true });
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Connexion impossible.');
      setBusy(false);
    }
  };

  return (
    <AuthLayout title="Connexion">
      {state?.passwordReset && !error && (
        <Alert severity="success" sx={{ mb: 2 }}>
          Mot de passe modifié.
        </Alert>
      )}
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      <Box component="form" onSubmit={submit} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <TextField
          label="E-mail"
          type="email"
          autoComplete="username"
          autoFocus
          required
          fullWidth
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <PasswordField
          label="Mot de passe"
          autoComplete="current-password"
          required
          fullWidth
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <Button type="submit" variant="contained" size="large" disabled={busy} sx={{ py: 1.25, mt: 1 }}>
          Se connecter
        </Button>
        <Link component={RouterLink} to="/mot-de-passe-oublie" state={{ email }} variant="body2" sx={{ alignSelf: 'center' }}>
          Mot de passe oublié
        </Link>
      </Box>
    </AuthLayout>
  );
}
